import React from 'react'
import { SpecialEditionProps } from '../SpecialEdition/SpecialEdition'
import {
    StyledEditionsPage,
    StyledEditionsSection,
    StyledEditionsHeading,
    StyledOnEditionList,
} from './PreviousSpecialEditions.styled'
import { SpecialEditionItem } from './components/EditionItem'
import { EditionV4DTO } from '@west-australian-newspapers/publication-types'

export interface NightlyPreviousSpecialEditionsProps {
    title?: string
    editions: EditionV4DTO[]
}

export const NightlyPreviousSpecialEditionsV2: React.FC<NightlyPreviousSpecialEditionsProps> =
    ({ editions, title = 'Latest Nightly On Editions' }) => {
        return (
            <StyledEditionsPage>
                <StyledEditionsSection>
                    <StyledEditionsHeading>
                        {editions.length > 0 && <h2>{title}</h2>}
                    </StyledEditionsHeading>

                    <StyledOnEditionList>
                        {editions.map((edition, idx) => (
                            <SpecialEditionItem
                                title={edition.title}
                                teaser={edition.teaser}
                                link={edition.editionWebUrl}
                                imageURL={edition.mainImages?.[0]?.src || ''}
                                lazyloadImages={true}
                                key={idx}
                                alt={edition.mainImages?.[0]?.captionText || ''}
                                publicationDate={edition.publicationDate}
                                path={edition.primaryTopic || ''}
                            />
                        ))}
                    </StyledOnEditionList>
                </StyledEditionsSection>
            </StyledEditionsPage>
        )
    }
